export const categories = [
  { key: "shoes", nameKey: "cat.shoes", url: "https://kaspreadsheet.com/category-911-Shoes.html", imageSeq: "cat-shoes-01" },
  { key: "hoodies", nameKey: "cat.hoodies", url: "https://kaspreadsheet.com/search-912/name/Shoes.html", imageSeq: "cat-hoodies-02" },
  { key: "tshirts", nameKey: "cat.tshirts", url: "https://kaspreadsheet.com/search-913/name/Shoes.html", imageSeq: "cat-tshirts-03" },
  { key: "jackets", nameKey: "cat.jackets", url: "https://kaspreadsheet.com/search-914/name/Shoes.html", imageSeq: "cat-jackets-04" },
  { key: "pants", nameKey: "cat.pants", url: "https://kaspreadsheet.com/search-915/name/Shoes.html", imageSeq: "cat-pants-05" },
  { key: "headwear", nameKey: "cat.headwear", url: "https://kaspreadsheet.com/search-916/name/Shoes.html", imageSeq: "cat-headwear-06" },
  { key: "sets", nameKey: "cat.sets", url: "https://kaspreadsheet.com/search-917/name/Shoes.html", imageSeq: "cat-sets-07" },
  { key: "underwear", nameKey: "cat.underwear", url: "https://kaspreadsheet.com/search-918/name/Shoes.html", imageSeq: "cat-underwear-08" },
  { key: "jersey", nameKey: "cat.jersey", url: "https://kaspreadsheet.com/search-919/name/Shoes.html", imageSeq: "cat-jersey-09" },
  { key: "accessories", nameKey: "cat.accessories", url: "https://kaspreadsheet.com/search-920/name/Shoes.html", imageSeq: "cat-accessories-10" },
  { key: "bags", nameKey: "cat.bags", url: "https://kaspreadsheet.com/search-921/name/Shoes.html", imageSeq: "cat-bags-11" },
  { key: "belts", nameKey: "cat.belts", url: "https://kaspreadsheet.com/search-922/name/Shoes.html", imageSeq: "cat-belts-12" },
  { key: "perfumes", nameKey: "cat.perfumes", url: "https://kaspreadsheet.com/search-923/name/Shoes.html", imageSeq: "cat-perfumes-13" },
  { key: "other", nameKey: "cat.other", url: "https://kaspreadsheet.com/search-924/name/Shoes.html", imageSeq: "cat-other-14" },
];

export const articleData = [
  {
    slug: "oopbuy-spreadsheet-guide",
    titleKey: "articles.guide1_title",
    descKey: "articles.guide1_desc",
    imageSeq: "article-guide-01",
    variant: "image" as const,
  },
  {
    slug: "oopbuy-spreadsheet-guide",
    titleKey: "articles.guide2_title",
    descKey: "articles.guide2_desc",
    imageSeq: "article-tips-02",
    variant: "accent" as const,
  },
  {
    slug: "oopbuy-spreadsheet-guide",
    titleKey: "articles.guide3_title",
    descKey: "articles.guide3_desc",
    imageSeq: "article-compare-03",
    variant: "image" as const,
  },
];